import { render, staticRenderFns } from "./Step-2.vue?vue&type=template&id=4120b8dc&scoped=true"
import script from "./Step-2.vue?vue&type=script&lang=js"
export * from "./Step-2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4120b8dc",
  null
  
)

export default component.exports